import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerAutorizacion = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
  }
  .success {
    color: var(--color-white);
    background-color: var(--color-danger);
  }
  .danger {
    color: var(--color-white);
    background-color: var(--color-broccoli);
  }
  .text-container {
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
    gap: 10px;
  }
  .ValidaTurno-separador {
    height: 2px;
    margin: 20px;
    background-color: var(--color-grey95);
  }
  .btn-container {
    display: flex;
    gap: 30px;
  }
`;
